import { render, staticRenderFns } from "./adminToolMovingAvgCalc.vue?vue&type=template&id=18676a1a&"
import script from "./adminToolMovingAvgCalc.vue?vue&type=script&lang=js&"
export * from "./adminToolMovingAvgCalc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports